import React from 'react';
import { ArrowLeft, Stethoscope, AlertCircle } from 'lucide-react';

const PreopMedicationGuide = ({ onBack }) => {
  return (
    <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-900 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-700 to-blue-900 dark:from-blue-800 dark:to-blue-950 text-white p-6 sticky top-0 z-10 shadow-lg">
        <button
          onClick={() => { onBack(); }}
          className="mb-4 p-2 hover:bg-white/10 rounded-lg transition-colors inline-flex items-center gap-2"
        >
          <ArrowLeft size={20} />
          <span className="text-sm">Clinical Tools</span>
        </button>
        <h1 className="text-3xl font-bold">Preop Medication Guide</h1>
        <p className="text-blue-100 text-sm mt-1">GLP-1, SGLT2-i & Perioperative Recommendations</p>
      </div>

      {/* Coming Soon Content */}
      <div className="px-6 mt-6 pb-8">
        <div className="bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-200 dark:border-blue-800 rounded-xl p-6 text-center">
          <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
            <Stethoscope className="text-blue-600 dark:text-blue-400" size={32} />
          </div>
          <h3 className="text-xl font-bold text-blue-900 dark:text-blue-200 mb-2">Coming Soon</h3>
          <p className="text-sm text-blue-800 dark:text-blue-300 mb-4">
            This section is currently under development and will include:
          </p>
          <ul className="text-left space-y-2 text-sm text-blue-800 dark:text-blue-300">
            <li className="flex items-start gap-2">
              <span className="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
              <span>GLP-1 agonist perioperative management</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
              <span>SGLT2 inhibitor recommendations</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
              <span>Preoperative medication guidelines</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
              <span>Evidence-based continuation/cessation protocols</span>
            </li>
          </ul>
        </div>

        {/* Info Box */}
        <div className="mt-6 bg-amber-50 dark:bg-amber-900/20 border-2 border-amber-200 dark:border-amber-800 rounded-xl p-4 flex items-start gap-3">
          <AlertCircle className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" size={20} />
          <div>
            <h4 className="font-semibold text-amber-900 dark:text-amber-200 text-sm mb-1">
              In Development
            </h4>
            <p className="text-xs text-amber-800 dark:text-amber-300">
              This clinical tool is being developed by the BCM Anesthesiology team. Check back soon for updates.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreopMedicationGuide;
